import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	missingFieldWarning: {
		id: 'servicedesk-incident-management-settings.common.new-field.missing-field-warning',
		defaultMessage: 'Field needs to be created',
		description:
			'Text that only appears when the field does not exist on the project instructing the user to create the field (using the warning flag that appears on this page).',
	},
});
